<script setup>
import BackArrow from '@components/back-arrow'
</script>

<template>
    <div>
        <div class="arrow">
            <BackArrow />
        </div>

        <div class="main">
            <div>
                <slot />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

$width: 500px;

.main {
    position: relative;
    width: $width;
    max-width: 100%;
    margin: 0 auto;
    text-align: center;
}

.arrow {
    position: absolute;
    top: $s-m;
    right: 0;
    left: 0;
    display: block;
    width: calc(#{$width - ($s-xl * 2)});
    margin: 0 auto;
    text-align: left;
}

@include tablet {
    .main {
        margin: $s-h auto 0;
    }
}
</style>
